/**WORDS SCREEN CARDS ICONS */
import img from '../assets/icons-lessons/unit1.png';
import img2 from '../assets/icons-lessons/unit2.png';
import img3 from '../assets/icons-lessons/unit3.png';
import img4 from '../assets/icons-lessons/unit4.png';
import img5 from '../assets/icons-lessons/unit5.png';
import img6 from '../assets/icons-lessons/unit6.png';
import img7 from '../assets/icons-lessons/unit7.png';
import img8 from '../assets/icons-lessons/unit8.png';
import img9 from '../assets/icons-lessons/unit9.png';
import img10 from '../assets/icons-lessons/unit10.png';
import img11 from '../assets/icons-lessons/unit11.png';
import img12 from '../assets/icons-lessons/unit12.png';
import img13 from '../assets/icons-lessons/unit13.png';
import img14 from '../assets/icons-lessons/unit14.png';
import img15 from '../assets/icons-lessons/unit15.png';

/**AUDIO SCREEN ICON FOR SECONDARY CONVERSTATION TO LESSON */
import company_audio_icon from '../assets/lesson3/company.png';
import meet_audio_icon from '../assets/lesson4/meet.png';
import rice_noodle_audio_icon from '../assets/lesson5/rice_noodle.png';
import watch_movie_icon from '../assets/lesson6/watch_movie_pic.png';
import enroll_pic_icon from '../assets/lesson7/enroll_pic.png';
import this_morning_pic_icon from '../assets/lesson8/this_morning_pic.png';
import temperature_pic_icon from '../assets/lesson9/temperature_pic.png';
import can_you_let_me_know_pic_icon from '../assets/lesson10/can_you_let_me_know_pic.png';
import mango_pic_audio_icon from '../assets/lesson11/mango_pic.png';
import volunteer_pic_audio_icon from '../assets/lesson12/volunteer_pic.png';
import homework_pic_audio_icon from '../assets/lesson13/homework_pic.png';
import landing_pic_audio_icon from '../assets/lesson14/landing_pic.png';

/** */
import start_conversation from '../assets/lesson_2/meet.png';
import introduce_yourself from '../assets/lesson_2/who.png';
import what_is from '../assets/lesson_2/andyou.png';
import six_tones from '../assets/conversation-icon/six_tones.png';
import pioneers from '../assets/background_promo.png';
import grammar from '../assets/baner-section/grammar.png';
import listening from '../assets/baner-section/listening.png';
import practice from '../assets/baner-section/practice.png';
import icon_market from "../assets/icon-market.png";
import icon_game from "../assets/icon-game.png";
import icon_device from "../assets/icon-device.png";
import icon_foot from "../assets/icon-foot.png";
import icon_correct from "../assets/icon-correct.png";
import icon_notcorrect from "../assets/icon-notcorrect.png";
import support_words from "../assets/support-words.png";
import support_audio from "../assets/support-audio.png";
import support_translate from "../assets/support-translate.png";
import window_translate_gif from "../assets/supports/gif-translate.gif";
import window_word from "../assets/supports/word.png";
import window_word_gif from "../assets/supports/gif-words.gif";
import window_audio from "../assets/supports/audio.png";
import window_audio_gif from "../assets/supports/gif-audio.gif";

/** PICTURES FOR LANDING, END and ERROR PAGES */
import window_translate from "../assets/supports/translate.png";
import background from "../assets/phone.png";
import appstore from '../assets/app-store-badge.png';
import googlestore from '../assets/google-play-badge.png';
import img_error from '../assets/error/error.png';
import end_screen from '../assets/end-screen/end-screen.png';
import promo_method from '../assets/promo-method/promo_method.png';
import dictionary from '../assets/dictionary/dictionary.png';
import mobile_advise from '../assets/mobile-advise/mobile_advise.png';

/**SOUND FOR AUDIO TEST LANDING PAGE */
import b2 from "../assets/sounds/pronunciation/Bà.mp3";
import b3 from "../assets/sounds/pronunciation/Bá.mp3";
import b4 from "../assets/sounds/pronunciation/Bã.mp3";

/**WORDS SCREEN LESSONS */
import { unit_15 } from "../dictionary/unit-15/unit_15";
import { unit_14 } from "../dictionary/unit-14/unit_14";
import { unit_13 } from "../dictionary/unit-13/unit_13";
import { unit_12 } from "../dictionary/unit-12/unit_12";
import { unit_11 } from "../dictionary/unit-11/unit_11";
import { unit_10 } from "../dictionary/unit-10/unit_10";
import { unit_9 } from "../dictionary/unit-9/unit_9";
import { unit_8 } from "../dictionary/unit-8/unit_8";
import { unit_7 } from "../dictionary/unit-7/unit_7";
import { unit_6 } from "../dictionary/unit-6/unit_6";
import { unit_5 } from "../dictionary/unit-5/unit_5";
import { unit_4 } from "../dictionary/unit-4/unit_4";
import { unit_3 } from "../dictionary/unit-3/unit_3";
import { unit_2 } from "../dictionary/unit-2/unit_2";
import { unit_1 } from "../dictionary/unit-1/unit_1";

/**AUDIO SCREEN LESSONS */
import { audio1, audio1_1} from "../dictionary/unit-1/audio1";
import { audio2,audio2_1,audio2_2 } from '../dictionary/unit-2/audio2';
import { audio3, audio3_1 } from '../dictionary/unit-3/audio3';
import { audio4, audio4_1 } from '../dictionary/unit-4/audio4';
import { audio5, audio5_1 } from '../dictionary/unit-5/audio5';
import { audio6, audio6_1 } from '../dictionary/unit-6/audio6';
import { audio7, audio7_1 } from '../dictionary/unit-7/audio7';
import { audio8, audio8_1 } from '../dictionary/unit-8/audio8';
import { audio9, audio9_1 } from '../dictionary/unit-9/audio9';
import { audio10, audio10_1 } from '../dictionary/unit-10/audio10';
import { audio11, audio11_1 } from '../dictionary/unit-11/audio11';
import { audio12, audio12_1 } from '../dictionary/unit-12/audio12';
import { audio13, audio13_1 } from '../dictionary/unit-13/audio13';
import { audio14, audio14_1 } from '../dictionary/unit-14/audio14';
import { audio15} from '../dictionary/unit-15/audio15';
import { pronunciation } from "../dictionary/unit-1/pronunciation";

/**ANIMATE FOR AUDIO-TEST LANDING PAGE */
import audio_animation_magnitola from '../assets/demo-audio/magnitola.png'
import audio_animation_note1 from '../assets/demo-audio/note1.png'
import audio_animation_note2 from '../assets/demo-audio/note2.png'
import audio_animation_terminal from '../assets/demo-audio/terminal.png'

/**SOUND FOR WORDS SCREEN */
import negative from "../assets/sounds/noncorrect.mp3";
import positive from "../assets/sounds/correct.mp3";

/**TRANSLATED DATA */

import {trans_1,trans_2,} from "../dictionary/unit-1/translated";
import {trans_2_2,} from "../dictionary/unit-2/translated_2";
import {trans_3_1,trans_3_2,} from "../dictionary/unit-3/translated_3";
import {trans_4_2,} from "../dictionary/unit-4/translated_4";
import {trans_5_1,trans_5_2,} from "../dictionary/unit-5/translated_5";
import {trans_6_1,trans_6_2,} from "../dictionary/unit-6/translated_6";
import {trans_7_2,} from "../dictionary/unit-7/translated_7";
import {trans_8_1,trans_8_2,} from "../dictionary/unit-8/translated_8";
import {trans_9_1,trans_9_2,} from "../dictionary/unit-9/translated_9";
import {trans_10_1,trans_10_2,} from "../dictionary/unit-10/translated_10";
import {trans_11_1,trans_11_2,} from "../dictionary/unit-11/translated_11";
import {trans_12_2,} from "../dictionary/unit-12/translated_12";
import {trans_13_1,trans_13_2,} from "../dictionary/unit-13/translated_13";
import {trans_14_1,trans_14_2,} from "../dictionary/unit-14/translated_14";
import {trans_15_1,trans_15_2,} from "../dictionary/unit-15/translated_15";
export const converstation={
    promo:{
        'title':'Let’s make learning <span style="color: rgb(63 98 18)" > Vietnamese language </span><span style="color:#ba4e4a" class="span_promo">fun</span> and <span style="color:#ba4e4a" class="span_promo">accessible</span>!',
        'title_vietnamese':'Hãy làm cho việc học <span style="color: rgb(63 98 18)" >Tiếng Việt</span> trở nên <span style="color:#ba4e4a" class="span_promo">thú vị</span> và <span style="color:#ba4e4a" class="span_promo">dễ tiếp cận</span>!',
        "subtitle":"Online Vietnamese language  in any place - all  for FREE! ...",
        'img': pioneers,
        'button_listen_sound':'listen sound',
        'button_start_learning':'start learning'
    },
    baner:[{
        id:1,
        src:listening,
        title:"Listen",
        text: "Practice pronunciation by listening to dialogues and texts",
        color:"text-lime-500"
      },{
        id:2,
        src:practice,
        title:"Practice",
        text: "Memorize new words with the help of tests in a playful way",
        color:'text-sky-500'
      },{
        id:3,
        src:grammar,
        title:"Grammar",
        text: "Learn about grammar and doing grammar exercises",
        color:'text-rose-500'
      }],
    words:{
        'title':'Chose group words for training',
        'section_img':support_words,
        'lessons':[{
            'id':0,
            'title':'Unit 1',
            'subtitle': 'Hello! I am David',
            'img':img,
            'array_data':unit_1
          },{
            'id':1,
            'title':'Unit 2',
            'subtitle': 'Where you from?',
            'img':img2,
            'array_data':unit_2
          },{
            'id':3,
            'title':'Unit 3',
            'subtitle': 'I am a doctor',
            'img':img3,
            'array_data':unit_3
           },{
            'id':4,
            'title':'Unit 4',
            'subtitle': 'How old is she?',
            'img':img4,
            'array_data':unit_4
           },{
            'id':5,
            'title':'Unit 5',
            'subtitle': 'How much is it?',
            'img':img5,
            'array_data':unit_5
           },{
            'id':6,
            'title':'Unit 6',
            'subtitle': 'We meet',
            'img':img6,
            'array_data':unit_6
           },{
            'id':7,
            'title':'Unit 7',
            'subtitle': 'When were you born?',
            'img':img7,
            'array_data':unit_7
           },{
            'id':8,
            'title':'Unit 8',
            'subtitle': 'Do you like food?',
            'img':img8,
            'array_data':unit_8
           }
           ,{
            'id':9,
            'title':'Unit 9',
            'subtitle': 'Weather today',
            'img':img9,
            'array_data':unit_9
           },{
            'id':10,
            'title':'Unit 10',
            'subtitle': 'What is Vietnam like?',
            'img':img10,
            'array_data':unit_10
           },{
            'id':11,
            'title':'Unit 11',
            'subtitle': 'Winter in Dalat and Hanoi',
            'img':img11,
            'array_data':unit_11
           },{
            'id':12,
            'title':'Unit 12',
            'subtitle': 'You live in Vietnam',
            'img':img12,
            'array_data':unit_12
           },{
            'id':13,
            'title':'Unit 13',
            'subtitle': 'Get to Hoan Kiem',
            'img':img13,
            'array_data':unit_13
           },{
            'id':14,
            'title':'Unit 14',
            'subtitle': 'You can sit here',
            'img':img14,
            'array_data':unit_14
           },{
            'id':15,
            'title':'Unit 15',
            'subtitle': 'You study vietnamese',
            'img':img15,
            'array_data':unit_15
           }
  ]
    },
    about:{      
        'background':background,
        'appstore':appstore,
        'googlestore':googlestore,
        'about':[
        {
          id: 1,
          title: "Free access",
          body: " Our mission is to make language learning accessible to everyone",
          img: icon_market,
       
        },
        {
          id: 2,
          title: "Learning in the game",
          body: " Game mechanics proven effective for all ages",
          img: icon_game,
        },
        {
          id: 3,
          title: "Practice anywhere",
          body: "Practice anywhere, with any device",
          img: icon_device,
        },
      ]},
    audio:{
        'title':'Chose audio to the conversation',
        'section_img':support_audio,
        'lessons':[{
            'id':1,
            'title':'My name is Dung',
            'subtitle': 'Introduce yourself. Say "Hello" people!',
            'img':img,
            'array_data':audio1
          },{
            'id':2,
            'title':'Where do you come from?',
            'subtitle': 'Introduce yourself. Say where you from and your nationality.',
            'img':img2,
            'array_data':audio1_1
          },{
            'id':3,
            'title':'What is?',
            'subtitle': 'Ansk and answer on common question.',
            'img':what_is,
            'array_data':audio2
          },{
            'id':4,
            'title':'Introduce yourself',
            'subtitle': 'Say people about you and start converstation easy.',
            'img':introduce_yourself,
            'array_data':audio2_1
          },{
            'id':5,
            'title':'Start conversation.',
            'subtitle': 'Starting a casual conversation.',
            'img':start_conversation,
            'array_data':audio2_2
          },{
            'id':6,
            'title': 'Six tones',
            'subtitle': 'The difference of the six tones',
            'img':six_tones,
            'array_data':pronunciation
          },{
            'id':7,
            'title': 'I am a doctor',
            'subtitle': 'What is your job?',
            'img':img3,
            'array_data':audio3
          },{
            'id':8,
            'title': 'My company',
            'subtitle': 'What company do you work for?',
            'img':company_audio_icon,
            'array_data':audio3_1
          } ,{
            'id':9,
            'title': 'How old is she?',
            'subtitle': 'Ask about age',
            'img':img4,
            'array_data':audio4
          },{
            'id':10,
            'title': 'Today we have a meeting',
            'subtitle': 'Speak about meeting',
            'img':meet_audio_icon,
            'array_data':audio4_1
          },{
            'id':11,
            'title': 'How much is it?',
            'subtitle': 'Ask about price',
            'img':img5,
            'array_data':audio5
          },{
            'id':12,
            'title': 'We want to eat bun cha!',
            'subtitle': 'Order food',
            'img':rice_noodle_audio_icon,
            'array_data':audio5_1
          },{
            'id':13,
            'title': 'We meet',
            'subtitle': 'Business',
            'img':img6,
            'array_data':audio6
          },{
            'id':14,
            'title': 'Are we going to the cinema?',
            'subtitle': 'Invite for a date',
            'img':watch_movie_icon,
            'array_data':audio6_1
          },{
            'id':15,
            'title': 'Where were you born?',
            'subtitle': 'Ask about age and where are you living',
            'img':img7,
            'array_data':audio7
          },{
            'id':16,
            'title': 'Register',
            'subtitle': 'Register yourself',
            'img':enroll_pic_icon,
            'array_data':audio7_1
          },{
            'id':17,
            'title': 'Do you like food?',
            'subtitle': 'Food',
            'img':img8,
            'array_data':audio8
          },{
            'id':18,
            'title': 'This morning',
            'subtitle': 'Mom and daughter have breakfast',
            'img':this_morning_pic_icon,
            'array_data':audio8_1
          },{
            'id':19,
            'title': 'Weather today',
            'subtitle': 'Talk about the weather',
            'img':img9,
            'array_data':audio9
          },{
            'id':20,
            'title': 'Tell me about the weather',
            'subtitle': 'Weather in the North and South of Vietnam',
            'img':temperature_pic_icon,
            'array_data':audio9_1
          },{
            'id':21,
            'title': 'What is Vietnam like?',
            'subtitle': 'Tourism',
            'img':img10,
            'array_data':audio10
          },{
            'id':22,
            'title': 'To work in Vietnam',
            'subtitle': 'Common question about Vietnam',
            'img':can_you_let_me_know_pic_icon,
            'array_data':audio10_1
          },{
            'id':23,
            'title': 'Winter in Dalat and Hanoi',
            'subtitle': 'Compare the weather in Vietnam',
            'img':img11,
            'array_data':audio11
          },{
            'id':24,
            'title': 'Buying mango',
            'subtitle': 'Which mango is cheaper?',
            'img':mango_pic_audio_icon,
            'array_data':audio11_1
          },{
            'id':25,
            'title': 'You live in Vietnam',
            'subtitle': 'Make contract and study vietnamese',
            'img':img12,
            'array_data':audio12
          },{
            'id':26,
            'title': 'Volunteers',
            'subtitle': 'Be a volunteer in vietnam',
            'img':volunteer_pic_audio_icon,
            'array_data':audio12_1
          },{
            'id':27,
            'title': 'Get to Hoan Kiem',
            'subtitle': 'Asking how to get there',
            'img':img13,
            'array_data':audio13
          },{
            'id':28,
            'title': 'School homework',
            'subtitle': 'School',
            'img':homework_pic_audio_icon,
            'array_data':audio13_1
          },{
            'id':29,
            'title': 'You can sit here',
            'subtitle': 'Business',
            'img':img14,
            'array_data':audio14
          },{
            'id':30,
            'title': 'Airport',
            'subtitle': 'Meet friends',
            'img':landing_pic_audio_icon,
            'array_data':audio14_1
          },{
            'id':31,
            'title': 'You study vietnamese',
            'subtitle': 'School',
            'img':img15,
            'array_data':audio15
          }
        ]
        
    },
    dictionary:{
        'title':'Course Dictionary', 
        'words_count':'The Course Dictionary includes ',
        'img':dictionary 
    },
    method:{
        'img':icon_foot,
        'group1':{
        'title':'3 step for first result:',
        'item':[{text:'Chose first group words for training'},
                {text:'Chose dialog for listen and repeat'},
                {text:'Chose sentenses for translate'},
              ]
        },

    },
    mobile_advise:{
      'img':mobile_advise,
      'group1':{
      'title':'Mobile application:',
      'item':[{text:'Regular updates of training modules, vocabulary and training'},
              {text:'Don not need internet connection to use'},
              {text:'Absolutely free to use'},
            ]
      },

  },
    translate:{
      'title':'Chose translate these sentences',
      'section_img':support_translate,
      'icon_correct':icon_correct,
      'icon_notcorrect':icon_notcorrect,
      'subtitle_vietnamese':'Translate the sentences into Vietnamese:',
      'subtitle_english':'Translate the sentences into English:',
      'item':[{
        'id':1,
        'title':'Hello! My name is David',
        'array_data':trans_1,
        'array_data_vietnamese':trans_2
      },{
        'id':2,
        'title':'Your Nationality?',
        'array_data':'',
        'array_data_vietnamese':trans_2_2
      },
      {
        'id':3,
        'title':'I am a doctor',
        'array_data':trans_3_1,
        'array_data_vietnamese':trans_3_2
      },
      {
        'id':4,
        'title':'How old is she?',
        'array_data':'',
        'array_data_vietnamese':trans_4_2
      },
      {
        'id':5,
        'title':'How much is it?',
        'array_data':trans_5_1,
        'array_data_vietnamese':trans_5_2
      },
      {
        'id':6,
        'title':'We meet',
        'array_data':trans_6_1,
        'array_data_vietnamese':trans_6_2
      },
      {
        'id':7,
        'title':'When were you born?',
        'array_data':'',
        'array_data_vietnamese':trans_7_2
      },
      {
        'id':8,
        'title':'Do you like food?',
        'array_data':trans_8_1,
        'array_data_vietnamese':trans_8_2
      },      
      {
        'id':9,
        'title':'Weather today',
        'array_data':trans_9_1,
        'array_data_vietnamese':trans_9_2
      },      
      {
        'id':10,
        'title':'What is Vietnam like?',
        'array_data':trans_10_1,
        'array_data_vietnamese':trans_10_2
      },      
      {
        'id':11,
        'title':'Winter in Dalat and Hanoi',
        'array_data':trans_11_1,
        'array_data_vietnamese':trans_11_2
      },      
      {
        'id':12,
        'title':'You live in Vietnam',
        'array_data':'',
        'array_data_vietnamese':trans_12_2
      },      
      {
        'id':13,
        'title':'Get to Hoan Kiem',
        'array_data':trans_13_1,
        'array_data_vietnamese':trans_13_2
      },      
      {
        'id':14,
        'title':'You can sit here',
        'array_data':trans_14_1,
        'array_data_vietnamese':trans_14_2
      },      
      {
        'id':15,
        'title':'You study vietnamese',
        'array_data':trans_15_1,
        'array_data_vietnamese':trans_15_2
      },
    ]
    },
    error:{
        'title':'404: Chose Main Page',
        'subtitle':'This page does not exist. Go back to main page.',
        'img':img_error
    },
    end_screen:{
        'title':'Congratulation you done training. Chose new test.',
        'picture':end_screen
    },
    landing:{
        'continue':'Continue more >>>'
    },
    button:{
        'button_name': 'Title Page',
        'button_name-training':'Training Page' 
    },
    support_window:{
      'img_word': window_word,
      'img_audio':window_audio,
      'img_translate':window_translate,
      'text_word': window_word_gif,
      'text_audio':window_audio_gif,
      'text_translate':window_translate_gif
    },
    demo_audio:{
      'subtitle':'Letter Sounds',
      'audio_animation_note1':audio_animation_note1,
      'audio_animation_note2':audio_animation_note2,
      'audio_animation_magnitola':audio_animation_magnitola,
      'audio_animation_terminal':audio_animation_terminal,
      'item': [ {
          id:1, 
          name: 'Bà',
          color:'text-[#529312]',
          audio:b2
      },
      {
          id:2, 
          name:'Bá',
          color:'text-[#EC9616]',
          audio:b3
      },   
      {
          id:3, 
          name:'Bã',
          color:'text-[#06B6D4]',
          audio:b4
      }
  ]
    },
    promo_method:{
      title:'Enjoy learning',
      text:"To learn the Vietnamese language, original modern texts and dialogues, sound recordings are used, and in the mobile application a mixture of the original text and translation",
      img:promo_method
    },
    demo_test:{
      'title':'Practice and memorise your',
      'subtitle':'words'
    },
    footer:{
      'company_name':'©VinLingua(Vietnamese lingua) ',
      'web_app_name':'Vietnamese Language school for foreigner'
    },
    header:{
      'words_training':'words',
      'audio_training':'audio',
      'translate_training':'translations',
      'grammar_training':'grammar',
    },
    words_sounds:{
      'negative':negative,
      'positive':positive,
    },
    answer:{
      'negative': 'Not Correct answer:',
      'positive':'Correct answer:'
    }
}
